const COOKIEBOT_EVENTS = [
  'CookiebotOnConsentReady',
  'CookiebotOnAccept',
  'CookiebotOnDecline',
] as const;

type CookiebotConsent = {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
};

declare global {
  interface Window {
    Cookiebot?: {
      consent?: CookiebotConsent;
      hasResponse: boolean;
      consented: boolean;
      declined: boolean;
      renew?: () => void;
    };
  }
}

export function getCookiebotStatisticsConsent(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return Boolean(window.Cookiebot?.consent?.statistics);
}

/**
 * Returns true only when the user has explicitly interacted with the Cookiebot
 * banner AND declined statistics cookies. Returns false in all other cases:
 * - Cookiebot not loaded yet
 * - User hasn't interacted with the banner
 * - User accepted statistics cookies
 *
 * This is the inverse of the previous "opt-in" approach. Tracking runs by
 * default and is only disabled on explicit decline — matching standard
 * non-EU cookie consent behavior.
 */
export function hasExplicitlyDeclinedStatistics(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const cookiebot = window.Cookiebot;
  if (!cookiebot?.hasResponse) {
    return false;
  }

  return cookiebot.consent?.statistics === false;
}

export function subscribeToCookiebotConsent(onStoreChange: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  for (const eventName of COOKIEBOT_EVENTS) {
    window.addEventListener(eventName, onStoreChange);
  }

  return () => {
    for (const eventName of COOKIEBOT_EVENTS) {
      window.removeEventListener(eventName, onStoreChange);
    }
  };
}
